import React, { useState, useEffect } from "react";
import styles from "../../../assets/scss/Billing/AddBilling.module.scss";
import Pagination from "../../../Components/Common/Pagination";
import PopupWrapper from "../../../Components/Common/PopupWrapper";
import AssetAddForm from "./AssetAddForm";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetAssetDetailsQuery } from "../../../slices/admin/admin";
import { toast } from "react-toastify";

const AssetSingleView = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [showPopup, setShowPopup] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const userId = queryParams.get("id");

    const { data, isLoading, isError, error } =
        useGetAssetDetailsQuery(userId);

    useEffect(() => {
        if (isError) {
            toast.error(error?.data?.message || "Failed to fetch asset details");
        }
    }, [isError]);

    const transactions = data?.data || [];
    const customer = data?.user || {};

    console.log(transactions, "transactions");
    

    const totalPages = Math.ceil(transactions.length / limit);
    const paginatedData = transactions.slice(
        (currentPage - 1) * limit,
        currentPage * limit
    );

    return (
        <div className={styles.billingContainer}>
            <div className={styles.header}>
                <h2 className={styles.tittle}>Box & Sack Ledger</h2>
                <span
                    className={styles.closeIcon}
                    onClick={() =>
                        navigate("/dashboard/billing", {
                            state: { activeTab: "Asset" }
                        })
                    }
                >
                    ✕
                </span>
            </div>

            <div className={styles.billingContainers}>
                <div className={styles.formSection}>
                    <div className={styles.ownerBoxxx}>
                        <p>
                            <strong>Transport Owner :</strong> {customer?.name}
                        </p>
                        <p>
                            <strong>Phone No :</strong> {customer?.phone}
                        </p>
                        <p>
                            <strong>Pending Box :</strong>{" "}
                            <span style={{ backgroundColor: "#ffe5e5", color: "#d32f2f", padding: "4px 10px", borderRadius: "12px", fontSize: "12px", fontWeight: "600", display: "inline-block" }}>
                                {data?.totalPendingBoxCount || 0}
                            </span>
                        </p>
                        <p>
                            <strong>Pending Sack :</strong>{" "}
                            <span style={{ backgroundColor: "#ffe5e5", color: "#d32f2f", padding: "4px 10px", borderRadius: "12px", fontSize: "12px", fontWeight: "600", display: "inline-block" }}>
                                {data?.totalPendingSackCount || 0}
                            </span>
                        </p>
                    </div>
                </div>
            </div>

            <div className={styles.billingContainers}>
                <div className={styles.itemsHeader}>
                    <h4>Transactions</h4>
                    <button
                        className={styles.addItemBtn}
                        onClick={() => setShowPopup(true)}
                    >
                        + Box & Sack Debit
                    </button>
                </div>

                <div className={styles.itemsSection}>
                    <div className={styles.tableWrapper}>
                        <table>
                            <thead>
                                <tr>
                                    <th>Receipt ID</th>
                                    <th>Transaction Date</th>
                                    <th>Status</th>
                                    <th>Type</th>
                                    <th>Sack Count</th>
                                    <th>Box Count</th>
                                </tr>
                            </thead>

                            <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan="5" style={{ textAlign: "center" }}>
                                            Loading...
                                        </td>
                                    </tr>
                                ) : paginatedData.length > 0 ? (
                                    paginatedData.map((txn) => (
                                        <tr key={txn._id}>
                                            <td>{txn.billId?.receiptNo || "Asset Return"}</td>
                                            <td>
                                                {new Date(txn.createdAt).toLocaleString("en-US")}
                                            </td>
                                            <td>
                                                <span
                                                    className={
                                                        txn.status === "returned"
                                                            ? styles.statusReturned
                                                            : styles.statusActive
                                                    }
                                                >
                                                    {txn.status}
                                                </span>
                                            </td>
                                            <td>
                                                <span
                                                    className={
                                                        txn.billId?.receiptNo?.startsWith("RB_")
                                                            ? styles.outBadge
                                                            : styles.inBadge
                                                    }
                                                >
                                                    {txn.billId?.receiptNo?.startsWith("RB_") ? "Out" : "In"}
                                                </span>
                                            </td>
                                            <td>{txn.actualSackCount || "0"}</td>
                                            <td>{txn.actualBoxCount || "0"}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5" style={{ textAlign: "center" }}>
                                            No transactions found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {/* <div className={styles.dflexamount}>
              <div>
                <h3>Total Sack Count :</h3>
              </div>
              <div>
                <h3>
                  {transactions.reduce(
                    (acc, curr) => acc + (curr.sackCount || 0),
                    0
                  )}
                </h3>
              </div>
            </div> */}
                    </div>

                    <div className={styles.paginationWrapper}>
                        <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={setCurrentPage}
                        />

                        <select
                            className={styles.inputsbtn}
                            value={limit}
                            onChange={(e) => setLimit(Number(e.target.value))}
                        >
                            <option value={10}>10 rows</option>
                            <option value={25}>25 rows</option>
                            <option value={50}>50 rows</option>
                        </select>
                    </div>
                </div>
            </div>

            {showPopup && (
                <PopupWrapper onClose={() => setShowPopup(false)}>
                    <AssetAddForm
                        userId={userId}
                        onClose={() => setShowPopup(false)}
                    />
                </PopupWrapper>
            )}
        </div>
    );
};

export default AssetSingleView;